import gql from 'graphql-tag';
import useAuth from './useAuth';
import { CURRENT_USER_FRAGMENT } from './useCurrentUser';

const LOGIN_MUTATION = gql`
  mutation loginWithPassword($email: String!, $password: String!) {
    loginWithPassword(email: $email, password: $password) {
      token
      refreshToken
      user {
        ...currentUser
      }
    }
  }
  ${CURRENT_USER_FRAGMENT}
`;

const useLogin = () => {
  const [login] = useAuth(LOGIN_MUTATION);
  return login;
};

export default useLogin;
